import Vue from "vue";
import store from "../store";
import GlobalVue from "../globalVue";
import { EMessageTypeConfig, EBillType } from "../enum/EBillType";
import _ from "lodash";
import { add } from "../helper/calucate";
var TABID_FLAG = "TAB_FLAG_";
var tabCount = 1;
var GRID_PREFIX = "CUSTOM_GRID_";
var RADIO_GROUP = "RADIO_GROUP_";
export function uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
}
export function generateGridId() {
    var tempUuid = uuid();
    return GRID_PREFIX + "_" + tempUuid;
}
export function createRadioName() {
    var tempUuid = uuid();
    return RADIO_GROUP + "_" + tempUuid;
}
export function createTab(con, props) {
    if (props === void 0) { props = {}; }
    var comp = new con({
        el: document.createElement("div"),
        store: store,
        data: props
    });
    var dom = document.createElement("div");
    Vue.nextTick(function () {
        dom.appendChild(comp.$el);
    });
    return {
        id: TABID_FLAG + tabCount++,
        dom: dom,
        comp: comp
    };
}
export function createTableBtn(text, cb) {
    return {
        template: "<button type=\"button\" @click=\"btnClick\" class=\"btn btn-link btn-sm ep-active\" data-toggle=\"dropdown\">\u6D4B\u8BD5\n                    </button>",
        methods: {
            btnClick: function () {
                cb(this.row);
            }
        }
    };
}
export function setTreeDisable(treeData) {
    treeData.forEach(function (item) {
        if (item.children && item.children.length) {
            item.isDisabled = true;
            setTreeDisable(item.children);
        }
        ;
    });
}
export function setTreeChildrenDisable(treeData) {
    treeData.forEach(function (item) {
        if (!item.children || !item.children.length) {
            item.isDisabled = true;
        }
        else {
            setTreeChildrenDisable(item.children);
        }
    });
}
export function summaries(param, showItems) {
    var columns = param.columns, data = param.data;
    var sums = [];
    columns.forEach(function (column, index) {
        if (index === 0) {
            sums[index] = '合计';
            return;
        }
        var showSum = showItems;
        if (showSum.indexOf(column.property) != -1) {
            var filter_1 = function (item) { return item[column.property]; };
            var fn = function (data) { return _.map(data, filter_1); };
            var result = _.flowRight(add, fn)(data).toFixedNoZero(4);
            sums[index] = result == 0 ? '' : result;
        }
        else {
            sums[index] = '';
        }
    });
    return sums;
}
export function toDetail(type, orderId, scope, cprops) {
    if (type == EBillType.DeliveryOrderDetailDocument) {
        var cpropsParams = Object.assign(cprops, {
            from_page: 'deliver',
            order_id: orderId,
        });
        GlobalVue.$emit("addTab", {
            component: EMessageTypeConfig[type].comp,
            title: EMessageTypeConfig[type].title,
            opener: scope || {},
            showExist: true,
            name: type.toString() + orderId,
            cprops: cpropsParams,
        });
    }
    else {
        var cpropsParams = {
            rowId: orderId,
        };
        if (cprops) {
            cpropsParams = Object.assign(cpropsParams, cprops);
        }
        GlobalVue.$emit("addTab", {
            component: EMessageTypeConfig[type].comp,
            title: EMessageTypeConfig[type].title,
            opener: scope || {},
            showExist: true,
            name: type.toString() + orderId,
            cprops: cpropsParams,
        });
    }
}
export function browserIsZoom() {
    var ratio = 0;
    var screen = window.screen;
    var ua = navigator.userAgent.toLowerCase();
    if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    }
    else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
    }
    else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth;
    }
    return ratio != 1;
}
export function getTheDayZeroTime(date) {
    var d = new Date(date);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d.getTime();
}
